//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RbModal from '@/elements/modal/rb-modal.vue'
import wcs from '@/scripts/libs/wcs'
import { Url } from '@/scripts/libs/url'

import { Cookies } from '@/scripts/libs/cookies'
import { ALREADY_CLOSED } from '@/scripts/constants/cookies'
import { mapGetters, mapActions } from 'vuex'
import { ACTION_UPDATE_NEWSLETTER_OPEN_STATUS } from '@/scripts/store/actions'

import RbNewsletterModalContent from '@/elements/newsletter-modal/newsletter-modal-content.lazy.vue'
import { scrollThreshold } from '@/scripts/constants/newsletter-modal'
import { EVENTS } from '@/scripts/constants/css-classes'
import { TABLET, MOBILE } from '@/scripts/constants/media-query'
import NewsletterModal from '@/scripts/libs/newsletter-modal'

export default {
  name: 'rb-newsletter-modal',
  components: {
    RbNewsletterModalContent,
    RbModal,
  },
  data: function () {
    return {
      errorMessage: '',
      signUpEmail: '',
      needsReload: false,
    }
  },
  computed: {
    ...mapGetters(['newsletterOpenStatus', 'userLoggedIn']),
    getModalStatus() {
      return this.newsletterOpenStatus && !window.location?.href.includes('store-locator')
    },
    canShowNewsletter() {
      return NewsletterModal.isEnabled(this.isMobileOrTablet) && !this.userLoggedIn
    },
    isMobileOrTablet() {
      return this.$mq === MOBILE || this.$mq === TABLET
    },
  },
  created: function () {
    window.addEventListener(EVENTS.SCROLL, this.handleScroll)
  },

  beforeDestroy() {
    window.removeEventListener(EVENTS.SCROLL, this.handleScroll)
  },
  mounted() {
    window.externalInvocationMethodMapping.showNewsletterModal = () => {
      this.openModal()
    }
    window.externalInvocationMethodMapping.closeNewsletterModal = () => {
      this.onCloseNewsletterModal()
    }
  },
  methods: {
    ...mapActions({
      updateNewsletterOpenStatus: ACTION_UPDATE_NEWSLETTER_OPEN_STATUS,
    }),
    openModal() {
      this.updateNewsletterOpenStatus(true)
    },
    closeModal() {
      Cookies.set(ALREADY_CLOSED, true)
      this.updateNewsletterOpenStatus(false)
      if (this.needsReload) {
        if (wcs.isInPlp()) {
          Url.updateUrl({ logged: 1 })
        }
        window.location.reload()
      }
    },
    setNeedsReloadStatus(status) {
      this.needsReload = status
    },
    onCloseNewsletterModal() {
      this.closeModal()
    },
    handleScroll() {
      const scrollPosition = window.pageYOffset || document.documentElement.scrollTop
      if (
        NewsletterModal.isEnabled(this.isMobileOrTablet) &&
        !NewsletterModal.isAlreadyClosedOrSigned() &&
        scrollPosition >= scrollThreshold
      ) {
        this.openModal()
      }
    },
  },
}
